import template from './contactViewImportantList.template.html';

export default {
  template,
  bindings: {
    items: '=',
    accounts: '=',
    onPin: '&',
    onToggle: '&',
    onLabelsSelect: '&',
    onEdit: '&',
    onDelete: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $filter, $mdMedia, $mdDialog, listImportantService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.currentOrganization = null;
      ctrl.list = listImportantService;
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.list.setData(ctrl.items);
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.itemPin = ($event, item) => {
        ctrl.onPin({ event: $event, item });
      };

      ctrl.itemToggle = ($event, item) => {
        if (item.docType.name === '__datum_job') {
          let canBeCompleted = true;
          if (item && item.items && item.items.length) {
            for (let i = 0; i < item.items.length; i++) {
              if (!item.items[i].isActive) {
                canBeCompleted = false;
                break;
              }
            }
          }
          if (canBeCompleted) {
            ctrl.onToggle({ item });
          } else {
            $mdDialog.show(
              $mdDialog
                .alert()
                .clickOutsideToClose(true)
                .title('Warning')
                .textContent('Not all sub-tasks have been completed.')
                .ariaLabel('Alert Dialog')
                .ok('Ok')
                .targetEvent($event)
            );
          }
        }
      };

      ctrl.itemLabelsSelect = ($event, item) => {
        ctrl.onLabelsSelect({ event: $event, item });
      };

      ctrl.itemEdit = ($event, item) => {
        ctrl.onEdit({ event: $event, item });
      };

      ctrl.itemDelete = ($event, item) => {
        ctrl.onDelete({ event: $event, item });
      };

      ctrl.getAccount = (idAccount) => ctrl.accounts.find((a) => a.id === idAccount);

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = (changes) => {
        if (changes.items && changes.items.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
